import { render, staticRenderFns } from "./Indemnities.vue?vue&type=template&id=5e8b4c75&scoped=true&"
import script from "./Indemnities.vue?vue&type=script&lang=js&"
export * from "./Indemnities.vue?vue&type=script&lang=js&"
import style0 from "./Indemnities.vue?vue&type=style&index=0&id=5e8b4c75&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b4c75",
  null
  
)

export default component.exports